module.exports = __webpack_public_path__ + "img/ico-P.ca7df12b.svg";